import http from '../../services/http-common';
import securityService from '../security/security.service';

class SellerService {
  getSellerForList() {
    return http.get(`/Seller/db/table`);
  }
  insert(data) {
    return http.post(`/Seller/db/add`, data);
  }
  update(data) {
    return http.put(`/Seller/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/Seller/db/delete/${PropertyID}`);
  }
}

export default new SellerService();